import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  display: flex;
  color: white;
  flex-direction: column;
  background-color: #060d22;
  position: relative;
  display: flex;
  flex-direction: column;
`;

export const Top = styled.div`
  position: sticky;
  top: 0;
  z-index: 10; /* Ensure it stays above other content */
  background-color: var(--mantine-color-body);
`;

export const Nav = styled.div`
  position: fixed;
  top: 60px; /* Aligns under the topbar */
  left: 0;
  height: calc(100vh - 60px); /* Full height minus topbar */
  width: 200px; /* Matches the grid-template-columns size */
  background-color: var(--mantine-color-body);
  z-index: 5; /* Stays below the topbar when overlapping */
  display: flex;
`;

export const Content = styled.div`
  margin-left: 200px; /* Avoids overlap with the fixed sidebar */
  display: flex;
  min-height: calc(100vh - 60px); /* Full height minus topbar */
  background: radial-gradient(circle, #0a1433, #060d22, #060d22);

  @media (max-width: 768px) {
    margin-left: 0;
  }
`;
